import React, { Component } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import AnimateHeight from 'react-animate-height'
import TemplateAccessStore from './store'
import Checkbox from '../form/Checkbox'
import './template-access.scss'
import Button from '../../UniformComponents/Button'
import Typography from '../../UniformComponents/Typography'

@observer
class TemplateAccess extends Component {
    constructor(props) {
        super(props)
        this.appStore = props.store
        this.isEmail = props.isEmail
        this.isNewTemplate = props.isNewTemplate || false
        this.templateAccessStore = this.isEmail
            ? props.templateSearchStore
            : new TemplateAccessStore(
                this.appStore,
                props.exposeUpdateBody || undefined,
                props.initBody || undefined,
            )

        this.state = {
            isAccOpen: {},
        }
    }

    async componentDidMount() {
        if (!this.isEmail) {
            await this.templateAccessStore.init()
        }
    }

    toggleDivision = (i) => {
        this.setState((prevState) => ({
            isAccOpen: {
                ...prevState.isAccOpen,
                [i]: !prevState.isAccOpen[i],
            },
        }))
    }

    renderCheckbox = (field, oid) => {
        const { toggleCheckbox, updating } = this.templateAccessStore
        return (
            <div className="form-checkbox-wrapper">
                {oid === 4 && <span>{i18n.t('gen_select_all')}</span>}
                <Checkbox
                    onBlur={(obj, e) => toggleCheckbox(obj, e, oid)}
                    name={field.name}
                    checked={field.checked}
                    valueid={field.id}
                    disabled={updating}
                    stopPropagation
                    // defaultChecked={field.checked} // if there is no need to update checkboxes on click
                />
            </div>
        )
    }

    renderSubmitButton = () => {
        const { updateTemplateAccess, updating } = this.templateAccessStore

        return !this.isNewTemplate && (
            <Button
                style={{ width: '80px' }}
                cssClass="uc-button regular save-button"
                variant="tertiary"
                onClick={updateTemplateAccess}
                disabled={updating}
                label={i18n.t('save')}
                icon="fal fa-floppy-disk"
            />
        )
    }

    renderSelectAll = (isMultiDivision) => {
        let el = null
        if (isMultiDivision) {
            const { checkboxOptions } = this.templateAccessStore
            const checked = Object.entries(checkboxOptions).every(([_, divisionData]) => divisionData.checked)
            const field = { name: 'All', checked }
            el = (
                <div className="select-all">
                    <p className="label-left">{i18n.t('all')}</p>
                    <div className="label-right">
                        <p>{i18n.t('gen_select_all')}</p>
                        {this.renderCheckbox(field, 3)}
                    </div>
                </div>
            )
        }
        return el
    }

    render() {
        const { fieldConfig, isExploriTemplate } = this.props
        if (isExploriTemplate) return null
        const { isAccOpen } = this.state
        const {
            label,
            client,
            checkboxOptions,
            hasRequiredError,
        } = this.templateAccessStore
        const cn = `check-acc-wrapper ${hasRequiredError ? 'required-error' : ''}`
        const { isMultiDivision } = client

        return (
            <div className={cn} style={fieldConfig?.style || null}>
                <div className="check-acc">
                    <div className="check-acc-header">
                        <i className="header-icon fa-solid fa-circle-info" />
                        <p className="header-label">{label}</p>
                        {this.renderSubmitButton()}
                    </div>
                    <div className="check-acc-body">
                        <hr className="acc-divider" />
                        <div className="option-list">
                            {this.renderSelectAll(isMultiDivision)}
                            {Object.keys(checkboxOptions).map((divisionId, idx) => (divisionId !== 'all'
                                ? (
                                    <div className="option" key={`${divisionId}_${idx}`}>
                                        {/* Divisions */}
                                        <div
                                            className="option-heading"
                                            onClick={() => { this.toggleDivision(idx) }}
                                        >
                                            <i className={`option-icon fa-regular ${isAccOpen[idx]
                                                ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                            />
                                            <p className="option-name">
                                                {isMultiDivision ? checkboxOptions[divisionId].name : client.name}
                                            </p>
                                            {this.renderCheckbox(checkboxOptions[divisionId], 4)}
                                        </div>
                                        <AnimateHeight
                                            className="option-acc"
                                            duration={250}
                                            height={isAccOpen[idx] ? 'auto' : 0}
                                        >
                                            <hr className="option-divider" />
                                            <div className="checks">
                                                {/* Portfolios */}
                                                {divisionId !== 'all' && checkboxOptions[divisionId].portfolios.map((p, pIndex) => (
                                                    <div key={`${p.id}_${pIndex}`} className="check-item">
                                                        <span>{p.name}</span>
                                                        {this.renderCheckbox(p, 5)}
                                                    </div>
                                                ))}
                                            </div>
                                        </AnimateHeight>
                                    </div>
                                ) : null))}
                        </div>
                    </div>
                </div>
                {hasRequiredError
                    ? (
                        <div className="error-container">
                            <Typography type="p" color="error">
                                {i18n.t('gen_select_one')}
                            </Typography>
                        </div>
                    ) : null}
            </div>
        )
    }
}

export default TemplateAccess
